import {StorageInstance} from "~/ts/library/storage/StorageFactory";
import {
    OPERATOR_APPLICATION_LANGUAGE_RU,
    OperatorApplicationDefaultLanguage,
    OperatorApplicationLanguagesList
} from "~/operatorApplication/ts/data/OperatorApplicationLanguagesList";
import Dictionary from "~/ts/library/Dictionary";
import axios from "axios";
import Translate, {__} from "~/ts/library/Translate";
import {ShortcutsList} from "~/operatorApplication/ts/service/shortcuts/ShortcutsList";
import {
    CHANGE_NOTIFICATIONS_CONFIG,
    CHANGE_SPELLCHECK_CONFIG,
    OPERATOR_RELOAD_APP_CONFIG,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {OPERATOR_STATUS_ONLINE, OperatorStatus} from "~/chat/ts/data/OperatorStatus";
import OperatorApplicationConfigInterface from "~/operatorApplication/ts/service/OperatorApplicationConfigInterface";
import {
    DEFAULT_OPERATOR_APP_HOST,
    INTERNATIONAL_OPERATOR_APP_HOST,
    toggleInternationHost
} from "~/core-ui/ts/Constants";
import {HIDDEN_BY_DEFAULT_BUTTON_IDS} from "~/operatorApplication/vue/dialogs/dialog/textarea/TextareaButtonInterface";
import WindowHelper from "~/ts/library/WindowHelper";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {computed} from "vue";
import OperatorApplicationServerSideConfigInterface
    from "~/operatorApplication/ts/service/OperatorApplicationServerSideConfigInterface";
import {BuddyListDisplayConfigItemInterface} from "~/operatorApplication/ts/service/getBuddyListDisplayConfigItems";


const LANGUAGE_ID = "languageId";

const BUDDY_LIST_SHOW_STATISTIC = "buddyListShowStatistic";
const BUDDY_LIST_SHOW_LAST_MESSAGE = "buddyListShowLastMessage";
const BUDDY_LIST_SHOW_LAST_MESSAGE_TOOLTIP = "buddyListShowLastMessageTooltip";
const BUDDY_LIST_DIALOG_STATE = "buddyListDialogState";
const BUDDY_LIST_SHOW_QUESTION_CATEGORY = "buddyListShowQuestionCategory";
const BUDDY_LIST_SHOW_REFERER = "buddyListShowReferer";
const BUDDY_LIST_SHOW_LAST_PAGE = "buddyListShowLastPage";
const BUDDY_LIST_SHOW_CLIENT_TAGS = "buddyListShowClientTags";
const BUDDY_LIST_SHOW_DIALOG_TAGS = "buddyListShowDialogTags";
const BUDDY_LIST_SHOW_ATTACHED_OPERATORS = "buddyListShowAttachedOperators";

const BUDDY_LIST_SHOW_OPERATORS = "buddyListShowOperators";
const BUDDY_LIST_SHOW_OPERATORS_OF_YOUR_GROUP_ONLY = "buddyListShowOperatorsOfYourGroupOnly";
const BUDDY_LIST_GROUP_BY_SITES = "buddyListGroupBySites";
const BUDDY_LIST_GROUP_SITES_BY_DOMAINS = "buddyListGroupSitesByDomains";
const BUDDY_LIST_GROUP_BY_STATE = "buddyListGroupByState";
const BUDDY_LIST_GROUP_BY_STATE_DEPENDS_ON_OPERATOR = "buddyListGroupByStateDependsOnOperator";
const CROSS_OPERATOR_BUDDY_LIST_GROUP_BY_SITES = "crossOperatorBuddyListGroupBySites";
const CROSS_OPERATOR_BUDDY_LIST_SHOW_LOGIN = "crossOperatorBuddyListShowLogin";
const CROSS_OPERATOR_BUDDY_LIST_SHOW_GROUP = "crossOperatorBuddyListShowGroup";

const AUTO_CLEAR_INITIATE_CHAT_FORM = "autoClearInitiateChatForm";

const BUDDY_LIST_GROUP_BY_INTEGRATION_PLATFORM = "buddyListGroupByIntegrationPlatform";
const BUDDY_LIST_TIME_FROM_LAST_QUESTION = "buddyListTimeFromLastQuestion";

const FAVORITE_EMOJI_LIST = "favoriteEmojiList";
const DARK_THEME_ENABLED = "darkThemeEnabled";
const DARK_THEME_AUTO_CHANGE_ENABLED = "darkThemeAutoChangeEnabled";

const CHAT_TEMPLATE_PREPEND_TO_TEXT = "prependTemplateToText";
const CHAT_AUTO_SUGGEST_TEMPLATES = "autoSuggestTemplates";
const CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES = "suggestAutoRememberedTemplates";
const CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES_FROM_SAME_SITE_ONLY = "suggestAutoRememberedTemplatesFromSameSiteOnly";

const CHAT_SHOW_SECONDS = "showSecondsInChat";
const CHAT_SHOW_DIALOGS = "showDialogsInChat";
const CHAT_SHOW_SYSTEM_MESSAGES = "showSystemMessagesInChat";

const HISTORY_BACKGROUND = "historyBackground";
const HISTORY_BACKGROUND_REPEAT = "historyBackgroundRepeat";
const CHAT_SPELLCHECK_LANGUAGES = "spellCheckLanguages";

const OPERATOR_MESSAGE_BACKGROUND = "operatorMessageBackground";
const CHAT_SEND_MESSAGE_SHORTCUT = "chatSendMessageShortcut";
const AUTO_AWAY_ON_AFK = "autoAwayOnAfk";
const AUTO_AWAY_ON_AFK_IDLE_THRESHOLD = "autoAwayOnAfkIdleThreshold";
const AUTO_AWAY_ON_LOCK = "autoAwayOnLock";

const SHOW_LICENSE_LIMIT_NOTIFICATION_AT_TOP = "showLicenseNotificationAtTop";

const DOWNLOAD_ENABLED = "downloadEnabled";
const SELFIE_SEGMENTATION_ENABLED = "selfieSegmentationEnabled";
const DOWNLOAD_PATH = "downloadPath";


const AUTO_CLEAR_CLOSED_DIALOGS_ENABLED = "autoClearClosedDialogsEnabled";
const AUTO_CLEAR_BUDDY_LIST_ENABLED = "autoClearBuddyListEnabled";
const AUTO_CLEAR_BUDDY_LIST_DELAY = "autoClearBuddyListDelay";
const YOU_IN_DIALOG_FOR_OFFLINE_NOTIFICATION = "youInDialogForOfflineNotification";
const CONFIRM_ON_REMOVE_FROM_BUDDY_LIST = "confirmOnRemoveFromBuddyList";


/*
const AUTO_INVISIBLE_ENABLED = "autoInvisibleEnabled";
const AUTO_INVISIBLE_TIME = "autoInvisibleTime";
const AUTO_INVISIBLE_DIALOG_COUNT = "autoInvisibleDialogCount";
const AUTO_INVISIBLE_CUSTOM_STATUS_ID = "autoInvisibleCustomStatusId";

const AUTO_INVISIBLE_LEAVE_ENABLE = "autoInvisibleLeaveEnabled";
const AUTO_INVISIBLE_LEAVE_DELAY = "autoInvisibleLeaveDelay";
const AUTO_INVISIBLE_LEAVE_ENABLED_FOR_MANUAL = "autoInvisibleLeaveEnabledForManual";
 */
const SCALED_UI = "scaledUi"
const UI_SCALE = "uiScale"
const CHAT_HISTORY_SCALE = "chatHistoryScale"
const CHAT_MESSAGE_REPLY_LINES = "chatHistoryMessageReplyLines"
const REMEMBER_LAST_OPERATOR_STATUS = "rememberLastOperatorStatus";
const LAST_OPERATOR_STATUS = "lastOperatorStatus";
const LAST_OPERATOR_CUSTOM_STATUS = "lastOperatorCustomStatus";

const MINIMIZE_TO_TRAY = "minimizeToTray";
const HIDE_NOT_FILLED_CLIENT_FIELDS = "hideNotFilledFields";
const SYMBOL_COUNT_IN_TEXTAREA = "symbolCountInTextarea";
const STICKY_DIALOG_INFO_ENABLED = "stickyDialogInfoEnabled";
const STICKY_DIALOG_INFO_ENABLED_ALWAYS = "stickyDialogInfoEnabledAlways";
const STICKY_DIALOG_INFO_TIMEOUT = "stickyDialogInfoTimeout";

const BUDDY_LIST_WIDTH = "buddyListWidth";
const DIALOG_SIDE_MENU_WIDTH = "dialogSideMenuWidth";
const DIALOG_WEB_RTC_SIDE_MENU_WIDTH = "dialogWebRtcSideMenuWidth";

const OPERATOR_STATUS_CHANGE_NOTIFICATIONS_ENABLED = "operatorStatusChangeNotificationsEnabled";
const OPERATOR_STATUS_CHANGE_NOTIFICATIONS_SOUND = "operatorStatusChangeNotificationsSound"

const NEW_MESSAGE_NOTIFICATIONS_ENABLED = "newMessageNotificationsEnabled";
const NEW_MESSAGE_NOTIFICATIONS_SOUND = "newMessageNotificationsSound"
const NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_SOUND = "newCrossOperatorMessageNotificationsSound"
const SKIP_MESSAGE_NOTIFICATION_WHEN_FOCUSED_AND_SELECTED = "skipMessageNotificationWhenFocusedAndSelected";
const NEW_DIALOG_NOTIFICATIONS_SOUND = "newDialogNotificationsSound"
const NEW_MESSAGE_NOTIFICATIONS_REPEAT = "newMessageNotificationsRepeat"
const NEW_DIALOG_NOTIFICATIONS_REPEAT = "newDialogNotificationsRepeat"
const NEW_MESSAGE_WINDOW_FOCUS = "newMessageWindowFocus"
const NEW_DIALOG_WINDOW_FOCUS = "newDialogWindowFocus"
const NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_REPEAT = "newCrossOperatorMessageNotificationsRepeat"

const OFFLINE_QUESTIONS_NOTIFICATIONS_ENABLED = "offlineQuestionsNotificationsEnabled";
const TARGET_CLIENT_NOTIFICATIONS_ENABLED = "targetClientNotificationsEnabled";
const TARGET_CLIENT_NOTIFICATIONS_SOUND = "targetClientNotificationsSound";
//const NEWS_NOTIFICATIONS_ENABLED = "newsNotificationsEnabled";
const AUTO_CLOSE_NOTIFICATIONS_ENABLED = "autoCloseNotificationsEnabled";
const AUTO_CLOSE_NOTIFICATIONS_DELAY = "autoCloseNotificationsDelay";
const IP_INFO_URL = "ipInfoUrl";

const APP_ICON_BADGE_TYPE = "appIconBadgeType";
const BUDDY_LIST_BADGE_TYPE = "buddyListBadgeType";
const SHOW_ANSWERED_NOT_TIME_MESSAGES = "showAnsweredNotInTimeMessages";


export const APP_ICON_BADGE_TYPE_CHATS = "chats";
export const APP_ICON_BADGE_TYPE_MESSAGES = "messages";

export const APP_ICON_BADGE_TYPE_TYPES = computed<{ id: string, label: string }[]>(() => ([
    {id: APP_ICON_BADGE_TYPE_CHATS, label: __("Непрочитанные чаты")},
    {id: APP_ICON_BADGE_TYPE_MESSAGES, label: __("Непрочитанные сообщения")}
]));


const NOTIFICATION_POSITION = "notificationPosition";
export const NOTIFICATION_POSITION_BOTTOM_RIGHT = "bottom-right";
export const NOTIFICATION_POSITION_BOTTOM_LEFT = "bottom-left";
export const NOTIFICATION_POSITION_TOP_RIGHT = "top-right";
export const NOTIFICATION_POSITION_TOP_LEFT = "top-left";

const STANDART_SOUND = "newMessage";
export const STANDART_NOTIFICATION_SOUNDS = computed<Dictionary<string>>(() => ({
    [STANDART_SOUND]: __("стандартный"),
    marimba: __("маримба"),
    wind: __("ветер"),
    click: __("клик"),
    signal: __("сигнал"),
    'tam-tam': __("там-там"),
    'tuk-tuk': __("стук"),
    off: __("отключить"),
}));

const CUSTOM_SHORTCUTS = "customShortcut";
/** @deprecated */
const TEMPLATE_SHORTCUTS = "templateShortcut";

const LAST_EMAIL_FOR_EXPORT = "lastEmailForExport";
const COBROWSE_SCALE = "cobrowseScale";

const WINDOW_SIZE = "windowSize";

export const SHORTCUTS_CHANGED_EVENT = "shortcutsChanged";


export const CHAT_SEND_MESSAGE_SHORTCUT_ENTER = "enter";
export const CHAT_SEND_MESSAGE_SHORTCUT_CTRL_ENTER = "ctrlenter";
export const CHAT_SEND_MESSAGE_SHORTCUT_META_ENTER = "metaenter";

let languageStrings: Dictionary<Dictionary<string>> = {
    [OperatorApplicationDefaultLanguage]: {}
};


class OperatorApplicationConfig implements OperatorApplicationConfigInterface, OperatorApplicationServerSideConfigInterface {
    private native = false;
    private internationalHostUsed: boolean = false;
    //private hostChecked: boolean = false;
    private inited = false;
    private darkThemeMatchMedia = window.matchMedia('(prefers-color-scheme: dark)');

    async init(isNative: boolean) {
        this.native = isNative;

        await this.useInternationalHostIfNeed();

        this.reloadLanguage();
        this.inited = true;


        this.darkThemeMatchMedia.addEventListener('change', () => {
            this.systemDarkThemeChanged();
        });
    }

    private systemDarkThemeChanged() {
        if (this.darkThemeAutoChangeEnabled) {
            if (this.darkThemeEnabled != this.darkThemeMatchMedia.matches) {
                this.darkThemeEnabled = this.darkThemeMatchMedia.matches;
            }
        }
    }

    get isInited() {
        return this.inited;
    }

    private get defaultHost(): string {
        return DEFAULT_OPERATOR_APP_HOST;
    }

    private get internationalHost(): string {
        return INTERNATIONAL_OPERATOR_APP_HOST;
    }

    public async useInternationalHostIfNeed() {
        this.useInternationalHost(false);
        //this.useInternationalHost();
        if (!(await this.asyncCheckConnection([this.defaultHost, "fileshare.zcdn.ru"]))) {
            if (await this.asyncCheckConnection([this.internationalHost])) {
                this.useInternationalHost(true);
            }
        }
    }

    private async asyncCheckConnection(hosts: string[]): Promise<boolean> {
        if (window.top && window.top !== window) {
            //не проверяем для iframe в кабинете
            return true;
        }
        let host: string = "";
        try {
            /*
            https://fileshare.zcdn.ru/cabinet/assets/operatorApplication/checkConnection.json
             */
            for (host of hosts) {
                await axios.get(`https://${host}/cabinet/assets/operatorApplication/checkConnection.json?t=${Date.now()}`, {
                    timeout: 2500
                });
            }
            return true;
        } catch (e) {
            console.error("Не удалось установить соединение с " + host, e);
            return false;
        }
    }

    useInternationalHost(value: boolean = true) {
        toggleInternationHost(value);
        this.internationalHostUsed = value;
    }

    get isInternationalHostUsed(): boolean {
        return this.internationalHostUsed;
    }

    public get productionHost() {
        return this.isInternationalHostUsed ? this.internationalHost : this.defaultHost;
    }

    get isNative() {
        return this.native;
    }

    private getConfig(key: string, defaultValue: any = null) {
        const serverSideConfig = OperatorAccountStore.isCabinetIframe ? undefined : OperatorAccountStore.data?.value?.applicationSettings;
        let value = serverSideConfig ? (serverSideConfig as any)[key] : null;
        value = value ?? StorageInstance.get(key);
        return value == null ? defaultValue : value;
    }

    private setConfig(key: string, value: any) {
        StorageInstance.set(key, value);
    }

    get darkThemeEnabled(): boolean {
        return this.getConfig(DARK_THEME_ENABLED, false);
    }

    set darkThemeEnabled(value: boolean) {
        this.setConfig(DARK_THEME_ENABLED, value);
        this.emitReloadAppConfig();
    }

    get darkThemeAutoChangeEnabled(): boolean {
        return this.getConfig(DARK_THEME_AUTO_CHANGE_ENABLED, false);
    }

    set darkThemeAutoChangeEnabled(value: boolean) {
        this.setConfig(DARK_THEME_AUTO_CHANGE_ENABLED, value);
        this.emitReloadAppConfig();
    }


    set languageId(id: string) {
        this.setConfig(LANGUAGE_ID, id);
    }

    get languageId(): string {
        return this.getConfig(LANGUAGE_ID, OperatorApplicationDefaultLanguage);
    }

    get language() {
        let language = OperatorApplicationLanguagesList.find(item => item.id == this.languageId);
        if (!language) {
            language = OperatorApplicationLanguagesList[0];
        }
        return language;
    }

    get windowSize(): WindowSizeInterface {
        return this.getConfig(WINDOW_SIZE, {
            width: 1024,
            height: 655,
            maximized: false,
            minimized: false
        } as WindowSizeInterface);
    }

    set windowSize(size: WindowSizeInterface) {
        if (!size.minimized) {
            this.setConfig(WINDOW_SIZE, size);
        }
    }

    private async reloadLanguage() {
        let langaugeId = this.languageId;
        if (langaugeId != OperatorApplicationDefaultLanguage) {
            if (!languageStrings[langaugeId]) {
                try {
                    let staticServer = this.isNative ? this.staticServer : '';
                    languageStrings[langaugeId] = (await axios.get(`${staticServer}/API/DOCS/metalkUpdates/localization/${langaugeId}.json?` + Date.now()))
                        .data;
                } catch (e) {
                    return;
                }
            }
        }
        if (languageStrings[langaugeId]) {
            Translate.setStrings(languageStrings[langaugeId]);
        }


        this.emitReloadAppConfig();
    }

    private emitReloadAppConfig() {
        this.systemDarkThemeChanged();
        OperatorApplicationEventManager.emit(OPERATOR_RELOAD_APP_CONFIG, this);
    }


    public get staticServer(): string {
        return this.internationalHostUsed ? "https://static.site-chat.me" : "https://static.me-talk.ru";
    }

    get isRussian() {
        return this.languageId == OPERATOR_APPLICATION_LANGUAGE_RU;
    }

    get crossOperatorBuddyListDisplayConfigItems(): BuddyListDisplayConfigItemInterface[] {
        let result: BuddyListDisplayConfigItemInterface[] = [
            {
                descr: __("Группировать чаты по сайтам"),
                getter: () => this.crossOperatorBuddyListGroupBySites,
                setter: (value: boolean) => this.crossOperatorBuddyListGroupBySites = value
            }
        ];
        if (OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin) {
            result.push({
                descr: __("Показывать логины операторов"),
                getter: () => this.crossOperatorBuddyListShowLogin,
                setter: (value: boolean) => this.crossOperatorBuddyListShowLogin = value
            });
        }
        if (this.crossOperatorBuddyListGroupBySites) {
            result.push(
                {
                    descr: __("Показывать название отдела"),
                    getter: () => this.crossOperatorBuddyListShowGroup,
                    setter: (value: boolean) => this.crossOperatorBuddyListShowGroup = value
                }
            );
        }
        return result;
    }

    get buddyListShowStatistic(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_STATISTIC, true);
    }

    set buddyListShowStatistic(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_STATISTIC, value);
    }

    get buddyListShowLastMessage(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_LAST_MESSAGE, true);
    }

    set buddyListShowLastMessage(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_LAST_MESSAGE, value);
    }

    get buddyListShowLastMessageTooltip(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_LAST_MESSAGE_TOOLTIP, true);
    }

    set buddyListShowLastMessageTooltip(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_LAST_MESSAGE_TOOLTIP, value);
    }


    get buddyListDialogState(): boolean {
        return this.getConfig(BUDDY_LIST_DIALOG_STATE, false);
    }

    set buddyListDialogState(value: boolean) {
        this.setConfig(BUDDY_LIST_DIALOG_STATE, value);
    }

    get buddyListShowQuestionCategory(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_QUESTION_CATEGORY, false);
    }

    set buddyListShowQuestionCategory(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_QUESTION_CATEGORY, value);
    }

    get buddyListShowReferer(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_REFERER, false);
    }

    set buddyListShowReferer(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_REFERER, value);
    }

    get buddyListShowLastPage(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_LAST_PAGE, false);
    }

    set buddyListShowLastPage(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_LAST_PAGE, value);
    }

    get buddyListShowClientTags(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_CLIENT_TAGS, true);
    }

    set buddyListShowClientTags(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_CLIENT_TAGS, value);
    }

    get buddyListShowDialogTags(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_DIALOG_TAGS, true);
    }

    set buddyListShowDialogTags(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_DIALOG_TAGS, value);
    }

    get buddyListShowAttachedOperators(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_ATTACHED_OPERATORS, false);
    }

    set buddyListShowAttachedOperators(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_ATTACHED_OPERATORS, value);
    }

    get buddyListShowOperators(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_OPERATORS, false);
    }

    set buddyListShowOperators(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_OPERATORS, value);
    }

    get buddyListShowOperatorsOfYourGroupOnly(): boolean {
        return this.getConfig(BUDDY_LIST_SHOW_OPERATORS_OF_YOUR_GROUP_ONLY, false);
    }

    set buddyListShowOperatorsOfYourGroupOnly(value: boolean) {
        this.setConfig(BUDDY_LIST_SHOW_OPERATORS_OF_YOUR_GROUP_ONLY, value);
    }

    get autoClearClosedDialogsBuddyListEnabled(): boolean {
        return this.getConfig(AUTO_CLEAR_CLOSED_DIALOGS_ENABLED, false);
    }

    set autoClearClosedDialogsBuddyListEnabled(value: boolean) {
        this.setConfig(AUTO_CLEAR_CLOSED_DIALOGS_ENABLED, value);
    }

    get showYouInDialogForOfflineNotification(): boolean {
        return this.getConfig(YOU_IN_DIALOG_FOR_OFFLINE_NOTIFICATION, true);
    }

    set showYouInDialogForOfflineNotification(value: boolean) {
        this.setConfig(YOU_IN_DIALOG_FOR_OFFLINE_NOTIFICATION, value);
    }


    get autoClearBuddyListEnabled(): boolean {
        return this.getConfig(AUTO_CLEAR_BUDDY_LIST_ENABLED, false);
    }

    set autoClearBuddyListEnabled(value: boolean) {
        this.setConfig(AUTO_CLEAR_BUDDY_LIST_ENABLED, value);
    }

    get confirmOnRemoveFromBuddyList(): boolean {
        return this.getConfig(CONFIRM_ON_REMOVE_FROM_BUDDY_LIST, false);
    }

    set confirmOnRemoveFromBuddyList(value: boolean) {
        this.setConfig(CONFIRM_ON_REMOVE_FROM_BUDDY_LIST, value);
    }

    get autoClearBuddyListDelay(): number {
        return this.getConfig(AUTO_CLEAR_BUDDY_LIST_DELAY, 86400 / 2);
    }

    set autoClearBuddyListDelay(value: number) {
        this.setConfig(AUTO_CLEAR_BUDDY_LIST_DELAY, value);
    }

    get buddyListGroupBySites(): boolean {
        return this.getConfig(BUDDY_LIST_GROUP_BY_SITES, true);
    }

    set buddyListGroupBySites(value: boolean) {
        this.setConfig(BUDDY_LIST_GROUP_BY_SITES, value);
    }

    get buddyListGroupSitesByDomains(): boolean {
        return this.getConfig(BUDDY_LIST_GROUP_SITES_BY_DOMAINS, false);
    }

    set buddyListGroupSitesByDomains(value: boolean) {
        this.setConfig(BUDDY_LIST_GROUP_SITES_BY_DOMAINS, value);
    }


    get buddyListGroupByState(): boolean {
        return this.getConfig(BUDDY_LIST_GROUP_BY_STATE, false);
    }

    set buddyListGroupByState(value: boolean) {
        this.setConfig(BUDDY_LIST_GROUP_BY_STATE, value);
    }

    get buddyListGroupByStateDependsOnOperator(): boolean {
        return this.getConfig(BUDDY_LIST_GROUP_BY_STATE_DEPENDS_ON_OPERATOR, true);
    }

    set buddyListGroupByStateDependsOnOperator(value: boolean) {
        this.setConfig(BUDDY_LIST_GROUP_BY_STATE_DEPENDS_ON_OPERATOR, value);
    }


    get crossOperatorBuddyListGroupBySites(): boolean {
        return this.getConfig(CROSS_OPERATOR_BUDDY_LIST_GROUP_BY_SITES, false);
    }

    set crossOperatorBuddyListGroupBySites(value: boolean) {
        this.setConfig(CROSS_OPERATOR_BUDDY_LIST_GROUP_BY_SITES, value);
    }

    get crossOperatorBuddyListShowLogin(): boolean {
        return OperatorAccountStore.data.value.accessRights.canViewOperatorsLogin && this.getConfig(CROSS_OPERATOR_BUDDY_LIST_SHOW_LOGIN, false);
    }

    set crossOperatorBuddyListShowLogin(value: boolean) {
        this.setConfig(CROSS_OPERATOR_BUDDY_LIST_SHOW_LOGIN, value);
    }

    get crossOperatorBuddyListShowGroup(): boolean {
        return this.getConfig(CROSS_OPERATOR_BUDDY_LIST_SHOW_GROUP, false);
    }

    set crossOperatorBuddyListShowGroup(value: boolean) {
        this.setConfig(CROSS_OPERATOR_BUDDY_LIST_SHOW_GROUP, value);
    }


    get autoClearInitiateChatForm(): boolean {
        return this.getConfig(AUTO_CLEAR_INITIATE_CHAT_FORM, false);
    }

    set autoClearInitiateChatForm(value: boolean) {
        this.setConfig(AUTO_CLEAR_INITIATE_CHAT_FORM, value);
    }


    get buddyListGroupByIntegrationPlatform(): boolean {
        return this.getConfig(BUDDY_LIST_GROUP_BY_INTEGRATION_PLATFORM, false);
    }

    set buddyListGroupByIntegrationPlatform(value: boolean) {
        this.setConfig(BUDDY_LIST_GROUP_BY_INTEGRATION_PLATFORM, value);
    }

    get buddyListShowTimeFromLastQuestion(): boolean {
        return this.getConfig(BUDDY_LIST_TIME_FROM_LAST_QUESTION, false);
    }

    set buddyListShowTimeFromLastQuestion(value: boolean) {
        this.setConfig(BUDDY_LIST_TIME_FROM_LAST_QUESTION, value);
    }

    get favoriteEmoji(): string[] {
        return this.getConfig(FAVORITE_EMOJI_LIST, []);
    }

    addFavoriteEmoji(emoji: string) {
        let list = this.favoriteEmoji;
        let i = list.indexOf(emoji);
        if (i > -1) {
            list.splice(i, 1);
        }
        list.unshift(emoji);
        if (list.length > 36) {
            list.pop();
        }
        this.setConfig(FAVORITE_EMOJI_LIST, list);
    }

    get ipInfoUrl() {
        return this.getConfig(IP_INFO_URL, "https://2ip.ru/whois/?ip=[ip]");
    }

    set ipInfoUrl(value: string) {
        this.setConfig(IP_INFO_URL, value);
    }

    get autoSuggestTemplates(): boolean {
        return this.getConfig(CHAT_AUTO_SUGGEST_TEMPLATES, true);
    }

    set autoSuggestTemplates(value: boolean) {
        this.setConfig(CHAT_AUTO_SUGGEST_TEMPLATES, value);
    }

    get prependTemplateToText(): boolean {
        return this.getConfig(CHAT_TEMPLATE_PREPEND_TO_TEXT, false);
    }

    set prependTemplateToText(value: boolean) {
        this.setConfig(CHAT_TEMPLATE_PREPEND_TO_TEXT, value);
    }


    get suggestAutoRememberedTemplates(): boolean {
        return this.getConfig(CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES, true);
    }

    set suggestAutoRememberedTemplates(value: boolean) {
        this.setConfig(CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES, value);
    }

    get suggestAutoRememberedTemplatesFromSameSiteOnline(): boolean {
        return this.getConfig(CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES_FROM_SAME_SITE_ONLY, true);
    }

    set suggestAutoRememberedTemplatesFromSameSiteOnline(value: boolean) {
        this.setConfig(CHAT_SUGGEST_AUTO_REMEMBERED_TEMPLATES_FROM_SAME_SITE_ONLY, value);
    }

    get stickyDialogInfoEnabledAlways(): boolean {
        return this.getConfig(STICKY_DIALOG_INFO_ENABLED_ALWAYS, false)
    }

    set stickyDialogInfoEnabledAlways(value: boolean) {
        this.setConfig(STICKY_DIALOG_INFO_ENABLED_ALWAYS, value)
    }


    get stickyDialogInfoEnabled(): boolean {
        return this.getConfig(STICKY_DIALOG_INFO_ENABLED, true)
    }

    set stickyDialogInfoEnabled(value: boolean) {
        this.setConfig(STICKY_DIALOG_INFO_ENABLED, value)
    }

    get stickyDialogInfoTimeout(): number {
        return this.getConfig(STICKY_DIALOG_INFO_TIMEOUT, 2000)
    }

    set stickyDialogInfoTimeout(value: number) {
        this.setConfig(STICKY_DIALOG_INFO_TIMEOUT, value)
    }

    get showSecondsInChat(): boolean {
        return OperatorAccountStore.isCabinetIframe ? true : this.getConfig(CHAT_SHOW_SECONDS, false);
    }

    set showSecondsInChat(value: boolean) {
        this.setConfig(CHAT_SHOW_SECONDS, value)
    }

    get showDialogsInChat(): boolean {
        return this.getConfig(CHAT_SHOW_DIALOGS, true)
    }

    set showDialogsInChat(value: boolean) {
        this.setConfig(CHAT_SHOW_DIALOGS, value)
    }

    get showSystemMessagesInChat(): boolean {
        return OperatorAccountStore.isCabinetIframe ? true : this.getConfig(CHAT_SHOW_SYSTEM_MESSAGES, true)
    }

    set showSystemMessagesInChat(value: boolean) {
        this.setConfig(CHAT_SHOW_SYSTEM_MESSAGES, value)
    }

    get operatorMessageBackground(): string {
        return this.getConfig(OPERATOR_MESSAGE_BACKGROUND, "blue")
    }

    set operatorMessageBackground(value: string) {
        this.setConfig(OPERATOR_MESSAGE_BACKGROUND, value)
    }

    get chatSendMessageShortcut(): string {
        return this.getConfig(CHAT_SEND_MESSAGE_SHORTCUT, CHAT_SEND_MESSAGE_SHORTCUT_ENTER)
    }

    set chatSendMessageShortcut(value: string) {
        this.setConfig(CHAT_SEND_MESSAGE_SHORTCUT, value)
    }

    private getTextareaButtonPinnedKey(buttonId: string): string {
        return `textareaButtonPinned_${buttonId}`;
    }

    isTextareaButtonPinned(buttonId: string): boolean {
        let defaultValue = !HIDDEN_BY_DEFAULT_BUTTON_IDS.includes(buttonId);
        return this.getConfig(this.getTextareaButtonPinnedKey(buttonId), defaultValue);
    }

    setTextareaButtonPinned(buttonId: string, value: boolean): void {
        this.setConfig(this.getTextareaButtonPinnedKey(buttonId), value);
    }

    get isAutoAwayOnAfkEnabled(): boolean {
        return this.getConfig(AUTO_AWAY_ON_AFK, this.isNative);
    }

    set isAutoAwayOnAfkEnabled(value: boolean) {
        this.setConfig(AUTO_AWAY_ON_AFK, value);
    }

    get autoAwayOnAfkIdleThreshold(): number {
        return this.getConfig(AUTO_AWAY_ON_AFK_IDLE_THRESHOLD, 300);
    }

    set autoAwayOnAfkIdleThreshold(seconds: number) {
        this.setConfig(AUTO_AWAY_ON_AFK_IDLE_THRESHOLD, seconds);
    }

    get isAutoAwayOnLockEnabled(): boolean {
        return this.getConfig(AUTO_AWAY_ON_LOCK, true);
    }

    set isAutoAwayOnLockEnabled(value: boolean) {
        this.setConfig(AUTO_AWAY_ON_LOCK, value);
    }

    get isShowLicenseNotificationAtTop(): boolean {
        return this.getConfig(SHOW_LICENSE_LIMIT_NOTIFICATION_AT_TOP, true);
    }

    set isShowLicenseNotificationAtTop(value: boolean) {
        this.setConfig(SHOW_LICENSE_LIMIT_NOTIFICATION_AT_TOP, value);
    }

    get isDownloadEnabled(): boolean {
        return this.getConfig(DOWNLOAD_ENABLED, true);
    }

    set isDownloadEnabled(value: boolean) {
        this.setConfig(DOWNLOAD_ENABLED, value);
    }

    get downloadPath(): string {
        return this.getConfig(DOWNLOAD_PATH);
    }

    set downloadPath(value: string) {
        this.setConfig(DOWNLOAD_PATH, value);
    }


    get isSelfieSegmentationEnabled(): boolean {
        return this.getConfig(SELFIE_SEGMENTATION_ENABLED, false);
    }

    set isSelfieSegmentationEnabled(value: boolean) {
        this.setConfig(SELFIE_SEGMENTATION_ENABLED, value);
    }


    isShortcutUsed(shortcut: string): boolean {
        if (shortcut == "Ctrl+Shift+Enter") {
            return true;
        }
        let list = ShortcutsList.list;
        for (let key in list) {
            if (list.hasOwnProperty(key)) {
                if (this.getShortcut(key) == shortcut) {
                    return true;
                }
            }
        }
        for (let item of this.customShortcuts) {
            if (item.shortcut == shortcut) {
                return true;
            }
        }
        return false;
    }

    getShortcut(action: string) {
        let defaultValue = ShortcutsList.list[action].defaultShortcut;
        return this.getConfig(`shortcut_${action}`, defaultValue);
    }

    setShortcut(action: string, shortcut: string) {
        this.setConfig(`shortcut_${action}`, shortcut);
        this.emitShortcutChanged();
    }

    get customShortcuts(): CustomShortcutInterface[] {
        let result: CustomShortcutInterface[] = this.getConfig(CUSTOM_SHORTCUTS, []);
        let templateShortcuts = this.templateShortcuts;
        if (templateShortcuts.length) {
            for (let templateShortcut of templateShortcuts) {
                result.push({
                    shortcut: templateShortcut.shortcut,
                    typeId: CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID,
                    payload: templateShortcut.templateId
                });
            }
            this.templateShortcuts = [];
            this.customShortcuts = result;
        }
        return result;
    }

    set customShortcuts(value: CustomShortcutInterface[]) {
        this.setConfig(CUSTOM_SHORTCUTS, value);
        this.emitShortcutChanged();
    }

    /** @deprecated */
    private get templateShortcuts(): TemplateShortcutInterface[] {
        return this.getConfig(TEMPLATE_SHORTCUTS, []);
    }

    /** @deprecated */
    private set templateShortcuts(value: TemplateShortcutInterface[]) {
        this.setConfig(TEMPLATE_SHORTCUTS, value);
        this.emitShortcutChanged();
    }

    private emitShortcutChanged() {
        OperatorApplicationEventManager.emit(SHORTCUTS_CHANGED_EVENT);
    }

    get lastEmailForExport(): string {
        return this.getConfig(LAST_EMAIL_FOR_EXPORT);
    }

    set lastEmailForExport(email: string) {
        this.setConfig(LAST_EMAIL_FOR_EXPORT, email);
    }

    get cobrowseScale(): number {
        return this.getConfig(COBROWSE_SCALE, 1);
    }

    set cobrowseScale(value: number) {
        this.setConfig(COBROWSE_SCALE, value);
    }

    get uiScale(): number {
        return this.getConfig(UI_SCALE, this.scaledUi ? 1.15 : 1);
    }

    set uiScale(value: number) {
        this.setConfig(UI_SCALE, value);
    }


    get chatHistoryScale(): number {
        return this.getConfig(CHAT_HISTORY_SCALE, 1);
    }

    set chatHistoryScale(value: number) {
        this.setConfig(CHAT_HISTORY_SCALE, value);
    }

    get chatMessageReplyLines(): number {
        return this.getConfig(CHAT_MESSAGE_REPLY_LINES, 5);
    }

    set chatMessageReplyLines(value: number) {
        this.setConfig(CHAT_MESSAGE_REPLY_LINES, value);
    }

    get scaledUi(): boolean {
        return this.getConfig(SCALED_UI, false);
    }

    set scaledUi(value: boolean) {
        this.setConfig(SCALED_UI, value);
    }

    get rememberLastOperatorStatus(): boolean {
        return this.getConfig(REMEMBER_LAST_OPERATOR_STATUS, !this.isNative);
    }

    set rememberLastOperatorStatus(value: boolean) {
        this.setConfig(REMEMBER_LAST_OPERATOR_STATUS, value);
    }

    get lastOperatorStatus(): OperatorStatus {
        return this.getConfig(LAST_OPERATOR_STATUS, OPERATOR_STATUS_ONLINE);
    }

    set lastOperatorStatus(value: OperatorStatus) {
        this.setConfig(LAST_OPERATOR_STATUS, value);
    }

    get lastOperatorCustomStatus(): string {
        return this.getConfig(LAST_OPERATOR_CUSTOM_STATUS);
    }

    set lastOperatorCustomStatus(value: string) {
        this.setConfig(LAST_OPERATOR_CUSTOM_STATUS, value);
    }


    get minimizeToTray(): boolean {
        return this.getConfig(MINIMIZE_TO_TRAY, false);
    }

    set minimizeToTray(value: boolean) {
        this.setConfig(MINIMIZE_TO_TRAY, value);
        this.emitReloadAppConfig();
    }

    get skipMessageNotificationWhenFocusedAndSelected(): boolean {
        return this.getConfig(SKIP_MESSAGE_NOTIFICATION_WHEN_FOCUSED_AND_SELECTED, true);
    }

    set skipMessageNotificationWhenFocusedAndSelected(value: boolean) {
        this.setConfig(SKIP_MESSAGE_NOTIFICATION_WHEN_FOCUSED_AND_SELECTED, value);
    }

    get operatorStatusChangeNotificationsEnabled(): boolean {
        return this.getConfig(OPERATOR_STATUS_CHANGE_NOTIFICATIONS_ENABLED, false);
    }

    set operatorStatusChangeNotificationsEnabled(value: boolean) {
        this.setConfig(OPERATOR_STATUS_CHANGE_NOTIFICATIONS_ENABLED, value);
    }

    get newMessageNotificationsEnabled(): boolean {
        return this.getConfig(NEW_MESSAGE_NOTIFICATIONS_ENABLED, true);
    }

    set newMessageNotificationsEnabled(value: boolean) {
        this.setConfig(NEW_MESSAGE_NOTIFICATIONS_ENABLED, value);
    }

    get offlineQuestionsNotificationsEnabled(): boolean {
        return this.getConfig(OFFLINE_QUESTIONS_NOTIFICATIONS_ENABLED, true);
    }

    set offlineQuestionsNotificationsEnabled(value: boolean) {
        this.setConfig(OFFLINE_QUESTIONS_NOTIFICATIONS_ENABLED, value);
    }

    get targetClientNotificationsEnabled(): boolean {
        return this.getConfig(TARGET_CLIENT_NOTIFICATIONS_ENABLED, true);
    }

    set targetClientNotificationsEnabled(value: boolean) {
        this.setConfig(TARGET_CLIENT_NOTIFICATIONS_ENABLED, value);
    }

    /*
    get newsNotificationsEnabled(): boolean {
        return this.getConfig(NEWS_NOTIFICATIONS_ENABLED, true);
    }

    set newsNotificationsEnabled(value: boolean) {
        this.setConfig(NEWS_NOTIFICATIONS_ENABLED, value);
    }*/

    get autoCloseNotificationsEnabled(): boolean {
        return this.getConfig(AUTO_CLOSE_NOTIFICATIONS_ENABLED, false);
    }

    set autoCloseNotificationsEnabled(value: boolean) {
        this.setConfig(AUTO_CLOSE_NOTIFICATIONS_ENABLED, value);
    }

    get autoCloseNotificationsDelay(): number {
        return this.getConfig(AUTO_CLOSE_NOTIFICATIONS_DELAY, 5);
    }

    set autoCloseNotificationsDelay(value: number) {
        this.setConfig(AUTO_CLOSE_NOTIFICATIONS_DELAY, value);
    }

    get notificationPosition(): string {
        return this.getConfig(NOTIFICATION_POSITION, NOTIFICATION_POSITION_BOTTOM_RIGHT);
    }

    set notificationPosition(value: string) {
        this.setConfig(NOTIFICATION_POSITION, value);
        OperatorApplicationEventManager.emit(CHANGE_NOTIFICATIONS_CONFIG);
    }

    private getSound(key: string, defaultValue: string = STANDART_SOUND) {
        let value = this.getConfig(key, defaultValue);
        if (value && !STANDART_NOTIFICATION_SOUNDS.value[value]) {
            if (this.isNative) {
                let fs = require("fs");
                if (!fs.existsSync(value)) {
                    value = STANDART_SOUND;
                }
            }
        }
        return value;
    }

    public getFullSoundPath(sound: string): string {
        if (STANDART_NOTIFICATION_SOUNDS.value[sound]) {
            sound = `assets/operatorApplication/sounds/${sound}.mp3`;
        }
        return sound;
    }

    get newMessageNotificationSound(): string {
        return this.getSound(NEW_MESSAGE_NOTIFICATIONS_SOUND);
    }

    set newMessageNotificationSound(value: string) {
        this.setConfig(NEW_MESSAGE_NOTIFICATIONS_SOUND, value);
    }

    get operatorStatusChangeNotificationSound(): string {
        return this.getSound(OPERATOR_STATUS_CHANGE_NOTIFICATIONS_SOUND);
    }

    set operatorStatusChangeNotificationSound(value: string) {
        this.setConfig(OPERATOR_STATUS_CHANGE_NOTIFICATIONS_SOUND, value);
    }

    get newMessageNotificationRepeat(): number {
        return this.getConfig(NEW_MESSAGE_NOTIFICATIONS_REPEAT, 0);
    }

    set newMessageNotificationRepeat(value: number) {
        this.setConfig(NEW_MESSAGE_NOTIFICATIONS_REPEAT, value);
    }

    get newMessageWindowFocus(): boolean {
        return this.getConfig(NEW_MESSAGE_WINDOW_FOCUS, false);
    }

    set newMessageWindowFocus(value: boolean) {
        this.setConfig(NEW_MESSAGE_WINDOW_FOCUS, value);
    }

    get newDialogWindowFocus(): boolean {
        return this.getConfig(NEW_DIALOG_WINDOW_FOCUS, false);
    }

    set newDialogWindowFocus(value: boolean) {
        this.setConfig(NEW_DIALOG_WINDOW_FOCUS, value);
    }

    get newCrossOperatorMessageNotificationSound(): string {
        return this.getSound(NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_SOUND, this.newMessageNotificationSound);
    }

    set newCrossOperatorMessageNotificationSound(value: string) {
        this.setConfig(NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_SOUND, value);
    }

    get newCrossOperatorMessageNotificationRepeat(): number {
        return this.getConfig(NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_REPEAT, this.newMessageNotificationRepeat);
    }

    set newCrossOperatorMessageNotificationRepeat(value: number) {
        this.setConfig(NEW_CROSS_OPERATOR_MESSAGE_NOTIFICATIONS_REPEAT, value);
    }


    get newDialogNotificationSound(): string {
        return this.getSound(NEW_DIALOG_NOTIFICATIONS_SOUND);
    }

    set newDialogNotificationSound(value: string) {
        this.setConfig(NEW_DIALOG_NOTIFICATIONS_SOUND, value);
    }

    get newDialogNotificationRepeat(): number {
        return this.getConfig(NEW_DIALOG_NOTIFICATIONS_REPEAT, 0);
    }

    set newDialogNotificationRepeat(value: number) {
        this.setConfig(NEW_DIALOG_NOTIFICATIONS_REPEAT, value);
    }

    get targetClientNotificationSound(): string {
        return this.getSound(TARGET_CLIENT_NOTIFICATIONS_SOUND);
    }

    set targetClientNotificationSound(value: string) {
        this.setConfig(TARGET_CLIENT_NOTIFICATIONS_SOUND, value);
    }

    get hideNotFilledClientFieldsEnabled(): boolean {
        return this.getConfig(HIDE_NOT_FILLED_CLIENT_FIELDS, true);
    }

    set hideNotFilledClientFieldsEnabled(value: boolean) {
        this.setConfig(HIDE_NOT_FILLED_CLIENT_FIELDS, value);
    }

    get symbolCountInTextareaEnabled(): boolean {
        return this.getConfig(SYMBOL_COUNT_IN_TEXTAREA, true);
    }

    set symbolCountInTextareaEnabled(value: boolean) {
        this.setConfig(SYMBOL_COUNT_IN_TEXTAREA, value);
    }

    get historyBackground(): string {
        if (this.darkThemeEnabled) {
            return null;
        } else {
            return this.getConfig(HISTORY_BACKGROUND, null);
        }
    }

    set historyBackground(backgroundImage: string) {
        this.setConfig(HISTORY_BACKGROUND, backgroundImage);
    }

    get historyBackgroundRepeat(): boolean {
        return this.getConfig(HISTORY_BACKGROUND_REPEAT, false);
    }

    set historyBackgroundRepeat(value: boolean) {
        this.setConfig(HISTORY_BACKGROUND_REPEAT, value);
    }

    get spellcheckLanguages(): string[] {
        return this.getConfig(CHAT_SPELLCHECK_LANGUAGES, [])
    }

    set spellcheckLanguages(langCodes: string[]) {
        this.setConfig(CHAT_SPELLCHECK_LANGUAGES, langCodes);
        OperatorApplicationEventManager.emit(CHANGE_SPELLCHECK_CONFIG);
    }

    get buddyListWidth(): number {
        return this.getConfig(BUDDY_LIST_WIDTH, 300);
    }

    set buddyListWidth(value: number) {
        this.setConfig(BUDDY_LIST_WIDTH, value);
    }

    get dialogSideMenuWidth(): number {
        return this.getConfig(DIALOG_SIDE_MENU_WIDTH, 340);
    }

    set dialogSideMenuWidth(value: number) {
        this.setConfig(DIALOG_SIDE_MENU_WIDTH, value);
    }

    get dialogWebRtcSideMenuWidth(): number {
        return this.getConfig(DIALOG_WEB_RTC_SIDE_MENU_WIDTH, WindowHelper.getSize().width - 500);
    }

    set dialogWebRtcSideMenuWidth(value: number) {
        this.setConfig(DIALOG_WEB_RTC_SIDE_MENU_WIDTH, value);
    }


    get standartBackgrounds() {
        let result: string[] = [];
        for (let i = 1; i <= 5; i++) {
            result.push(`assets/operatorApplication/images/background/${i}.jpg`);
        }
        return result;
    }

    get appIconBadgeType(): string {
        return this.getConfig(APP_ICON_BADGE_TYPE, APP_ICON_BADGE_TYPE_CHATS);
    }

    set appIconBadgeType(value: string) {
        this.setConfig(APP_ICON_BADGE_TYPE, value);
    }

    get buddyListBadgeType(): string {
        return this.getConfig(BUDDY_LIST_BADGE_TYPE, APP_ICON_BADGE_TYPE_MESSAGES);
    }

    set buddyListBadgeType(value: string) {
        this.setConfig(BUDDY_LIST_BADGE_TYPE, value);
    }

    get showAnsweredNotInTimeMessages(): boolean {
        return OperatorAccountStore.isCabinetIframe ? true : this.getConfig(SHOW_ANSWERED_NOT_TIME_MESSAGES, false);
    }

    set showAnsweredNotInTimeMessages(value: boolean) {
        this.setConfig(SHOW_ANSWERED_NOT_TIME_MESSAGES, value);
    }
}


export const OperatorApplicationConfigInstance = new OperatorApplicationConfig();

/**
 * @deprecated
 */
interface TemplateShortcutInterface {
    shortcut: string;
    templateId: string;
}

export const CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID = "useMessageTemplate";
export const CUSTOM_SHORTCUT_START_BOT_TYPE_ID = "startBot";
export const CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID = "sendForm";
export const CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID = "sendInfo";
export const CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID = "openLinkFromClientInfo";
export const CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID = "changeOperatorStatus";


export type CustomShortcutTypeId =
    typeof CUSTOM_SHORTCUT_USE_MESSAGE_TEMPLATE_TYPE_ID
    | typeof CUSTOM_SHORTCUT_SEND_FORM_TYPE_ID
    | typeof CUSTOM_SHORTCUT_SEND_INFO_TYPE_ID
    | typeof CUSTOM_SHORTCUT_OPEN_LINK_FROM_CLIENT_INFO_TYPE_ID
    | typeof CUSTOM_SHORTCUT_CHANGE_OPERATOR_STATUS_TYPE_ID
    | typeof CUSTOM_SHORTCUT_START_BOT_TYPE_ID;


export interface CustomShortcutInterface {
    shortcut: string;
    typeId: CustomShortcutTypeId;
    payload: string
}

export interface WindowSizeInterface {
    width: number;
    height: number;
    maximized: boolean;
    minimized: boolean;
}


export interface CustomShortcutChangeOperatorStatusPayloadInterface {
    statusId: OperatorStatus,
    customStatusId: string
}